module.exports = __webpack_public_path__ + "static/media/eportfolio-img.b98ae4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-it-works-assessment-signature/eportfolio-img.png
// module id = 377
// module chunks = 0